import { render, staticRenderFns } from "./ChallengeAvailable.vue?vue&type=template&id=35765093"
import script from "./ChallengeAvailable.vue?vue&type=script&lang=js"
export * from "./ChallengeAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports